<div *ngIf="!selectionService.selection.selected.length" class="ddlLabel">No Documents Selected</div>
<div style="
  display: flex;
    flex-direction: row;
    align-items: baseline;
">
  <mat-form-field>
    <mat-label>--- Select Field ---</mat-label>
    <mat-select (selectionChange)="addDocs($event)" [(ngModel)]="multiSelectField" [disabled]="!selectionService.selection.selected.length || !ucs.inRoles(Role.EditFeatureSet)">
      <mat-optgroup *ngFor="let group of multiDocGroups" [label]="group.displayTitle">
        <mat-option *ngFor="let field of group.fields" [value]="field">
          {{field.displayTitle}}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button color="primary" (click)="addNewField()" matTooltip="Add New Field" *ngIf="ucs.inRoles(Role.ManageCustomDocFieldsFeatureSet)"><mat-icon>add</mat-icon></button>
</div>